
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export default function Canonical() {
  const { pathname } = useLocation();

  const canonical = `${process.env.REACT_MAIN_URL}${pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}
